import React from "react";
import { useTranslation } from "react-i18next";
import PlusCircle from "../../../../assets/plus-circle.png";
import Button from "../../../Common/Buttons/Button";

interface BeneficiaryActionsProps {
  beneficiariesCount: number;
  isUserEnrolled?: boolean;
  isSubmitting: boolean;
  isFormValid: boolean;
  onAddBeneficiary: () => void;
  onNext: () => void;
  onPrevious: () => void;
  onCancel?: () => void;
}

const BeneficiaryActions: React.FC<BeneficiaryActionsProps> = ({
  beneficiariesCount,
  isUserEnrolled,
  isSubmitting,
  isFormValid,
  onAddBeneficiary,
  onNext,
  onPrevious,
  onCancel,
}) => {
  const { t } = useTranslation();

  const renderAddBeneficiaryButton = () => {
    if (isUserEnrolled) return null;

    return (
      <>
        <hr />
        <div className="bg-white rounded-b-[16px] md:shadow-md px-[16px] py-[32px] md:p-[32px]">
          <button
            data-testid="add-beneficiary-btn"
            onClick={onAddBeneficiary}
            className="text-[#00ADAC] h-[24px] flex items-center space-x-2"
          >
            <img className="w-[20px] h-[20px]" src={PlusCircle} alt="Plus" />
            <p>
              {t("onboarding.beneficiaries.add_beneficiary_numbered", {
                number: beneficiariesCount + 1,
              })}
            </p>
          </button>
        </div>
      </>
    );
  };

  const renderNavigationButtons = () => {
    return (
      <div
        className={`flex items-center space-x-4 lg:space-x-0 bg-white ${
          isUserEnrolled
            ? "gap-4"
            : "justify-between mt-[24px] md:shadow-md rounded-[16px] px-0 py-[32px] md:p-[32px]"
        }`}
      >
        <div
          className={`${isUserEnrolled ? "w-full" : "flex-1 lg:flex-none lg:w-[218px]"}`}
        >
          <Button
            ariaLabel="previous"
            variant="secondary"
            label={
              isUserEnrolled
                ? t("common.buttons.cancel")
                : t("common.buttons.previous")
            }
            iconAlignment="left"
            handleClick={isUserEnrolled ? onCancel || onPrevious : onPrevious}
          />
        </div>
        {!isUserEnrolled && (
          <div className="hidden lg:block flex-1 text-center">
            <p className="leading-[127%] font-normal text-[14px] text-[#C6C6C6]">
              {t("common.progress.step_counter", { current: 1, total: 4 })}
            </p>
          </div>
        )}
        <div
          className={`${isUserEnrolled ? "w-full" : "flex-1 lg:flex-none lg:w-[218px]"}`}
        >
          <Button
            iconVisibility="show"
            ariaLabel="next"
            label={t("common.buttons.next")}
            loading={isSubmitting}
            isDisabled={!isFormValid || isSubmitting}
            handleClick={onNext}
          />
        </div>
      </div>
    );
  };

  return (
    <>
      {renderAddBeneficiaryButton()}
      {renderNavigationButtons()}
    </>
  );
};

export default BeneficiaryActions;
